import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BranchProvider } from "@/context/BranchContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Items from "@/pages/Items";
import Stock from "@/pages/Stock";
import Transfers from "@/pages/Transfers";
import Suppliers from "@/pages/Suppliers";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Wastage from "@/pages/Wastage";
import StockCounts from "@/pages/StockCounts";
import Reports from "@/pages/Reports";
import Staff from "@/pages/Staff";
import Branches from "@/pages/Branches";

function Protected({ children }) {
  const { auth } = useAuth();
  if (auth === undefined)
    return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  if (!auth) return <Navigate to="/auth" replace />;
  if (!auth.membership) return <Navigate to="/onboarding" replace />;
  return <BranchProvider>{children}</BranchProvider>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/items" element={<Items />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/transfers" element={<Transfers />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/purchase-orders" element={<PurchaseOrders />} />
        <Route path="/wastage" element={<Wastage />} />
        <Route path="/stock-counts" element={<StockCounts />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/branches" element={<Branches />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}
